import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContactUsAlertComponent } from '@shared/components/contact-us-alert/contact-us-alert.component';
@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private dialog = inject(MatDialog);
  private _snackBar = inject(MatSnackBar);
  private readonly mobileQuery = 'screen and (max-width: 599px)';
  breakpointObserver = inject(BreakpointObserver);
  isMobile: boolean = false;

  constructor() {
    this.breakpointObserver.observe([this.mobileQuery]).subscribe((state: BreakpointState) => {
      this.isMobile = state.breakpoints[this.mobileQuery];
    });
  }

  successAlert(text: string = 'Operation Success') {
    this.openSnackBar(text, 'success');
  }

  failedAlert(text: string = 'Operation Failed') {
    this.openSnackBar(text, 'failed');
  }

  unauthorizedAlert(text: string = 'unauthorized') {
    this.openSnackBar(text, 'failed');
  }

  serverErrorAlert(text: string = 'Server Error') {
    this.openSnackBar(text, 'failed');
  }

  openSnackBar(text: string, type: string) {
    this._snackBar.open(text, '', {
      panelClass: type,
      horizontalPosition: 'end',
      verticalPosition: this.isMobile ? 'top' : 'bottom',
      duration: 3000,
    });
  }

  contactUs() {
    this.dialog.open(ContactUsAlertComponent);
  }
}
